import * as React from 'react';
export const lotteSvg = React.forwardRef(function lotteSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E60013',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.94 25.958c-2.717 2.718-7.163 2.718-9.88 0L6.038 20.94c-2.719-2.718-2.719-7.167 0-9.885l5.02-5.017c2.718-2.719 7.164-2.719 9.882 0l5.02 5.017c2.719 2.718 2.719 7.167 0 9.885l-5.02 5.017Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.023 23.37a.738.738 0 0 1-.543-1.242.742.742 0 1 1 .58 1.242h-.033m2.696-13.702c-.408 0-.736.127-.998.39-.569.564-.867 1.734-.842 3.286.033 1.916.488 5.676 1.997 7.611.244.314.506.561.78.744.265.178.568.346 1.03.346.128 0 .263-.011.401-.037.864-.211 1.95-1.17 2.751-2.452a.668.668 0 0 1 .918-.211c.15.095.252.244.295.415a.676.676 0 0 1-.083.503c-1.02 1.618-2.365 2.754-3.597 3.042-.007 0-.018 0-.032.008-.226.04-.448.062-.66.062-.794 0-1.355-.303-1.756-.565a4.729 4.729 0 0 1-1.097-1.039c-2.124-2.725-2.266-7.837-2.277-8.409-.022-1.359.171-3.199 1.235-4.256.518-.513 1.17-.772 1.931-.772h.124c.762 0 1.414.259 1.931.772 1.06 1.057 1.257 2.897 1.235 4.256-.021 1.414-.28 4.161-1.752 6.62a.665.665 0 1 1-1.14-.681c1.027-1.72 1.526-3.614 1.563-5.96.025-1.557-.274-2.723-.838-3.287-.263-.263-.59-.39-.999-.39h-.116l-.004.004Z',
      fill: '#E60013',
    }),
  );
});
lotteSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lotte = {
  category: 'brand',
  colorable: false,
  name: 'lotte',
  svg: lotteSvg,
};
